import { useSearchParams } from "next/navigation"

export default function useIsDebug5Col() {
	const searchParams = useSearchParams()
	return !!searchParams.get("debug5")
}
